module.exports = "/_next/static/images/congratulation-background-8b87f26bf5f1855c0f1beb12fbce1d36.jpg";